/* @generated from adl module ferovinum.app.internalapi */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_http from './../../common/http';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';

export interface InternalApiRequests {
  createSlackNotification: common_http.HttpPost<SlackNotification, Ok>;
  createPhysicalAddressInternal: common_http.HttpPost<CreatePhysicalAddressRequest, CreatePhysicalAddressResponse>;
}

export function makeInternalApiRequests(
  input: {
    createSlackNotification?: common_http.HttpPost<SlackNotification, Ok>,
    createPhysicalAddressInternal?: common_http.HttpPost<CreatePhysicalAddressRequest, CreatePhysicalAddressResponse>,
  }
): InternalApiRequests {
  return {
    createSlackNotification: input.createSlackNotification === undefined ? {path : "/notifications/slack/create", security : {kind : "internalApiToken"}, rateLimit : null, reqType : texprSlackNotification(), respType : texprOk()} : input.createSlackNotification,
    createPhysicalAddressInternal: input.createPhysicalAddressInternal === undefined ? {path : "/physical-addresses", security : {kind : "internalApiToken"}, rateLimit : null, reqType : texprCreatePhysicalAddressRequest(), respType : texprCreatePhysicalAddressResponse()} : input.createPhysicalAddressInternal,
  };
}

const InternalApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"createSlackNotification","default":{"kind":"just","value":{"path":"/notifications/slack/create","security":"internalApiToken"}},"name":"createSlackNotification","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"SlackNotification"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"Ok"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createPhysicalAddressInternal","default":{"kind":"just","value":{"path":"/physical-addresses","security":"internalApiToken"}},"name":"createPhysicalAddressInternal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"CreatePhysicalAddressRequest"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"CreatePhysicalAddressResponse"}},"parameters":[]}]}}]}},"name":"InternalApiRequests","version":{"kind":"nothing"}}};

export const snInternalApiRequests: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"InternalApiRequests"};

export function texprInternalApiRequests(): ADL.ATypeExpr<InternalApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snInternalApiRequests}, parameters : []}};
}

/**
 * Internal JAVA to NODE request for creating physical address
 */
export interface CreatePhysicalAddressRequest {
  entityId: common_strings.StringNE;
  addressType: ferovinum_app_db.PhysicalAddressType;
  line1: common_strings.StringNE;
  line2: (common_strings.StringNE|null);
  line3: (common_strings.StringNE|null);
  town: common_strings.StringNE;
  state: (common_strings.StringNE|null);
  postCode: common_strings.StringNE;
  country: common.Country;
}

export function makeCreatePhysicalAddressRequest(
  input: {
    entityId: common_strings.StringNE,
    addressType: ferovinum_app_db.PhysicalAddressType,
    line1: common_strings.StringNE,
    line2?: (common_strings.StringNE|null),
    line3?: (common_strings.StringNE|null),
    town: common_strings.StringNE,
    state?: (common_strings.StringNE|null),
    postCode: common_strings.StringNE,
    country: common.Country,
  }
): CreatePhysicalAddressRequest {
  return {
    entityId: input.entityId,
    addressType: input.addressType,
    line1: input.line1,
    line2: input.line2 === undefined ? null : input.line2,
    line3: input.line3 === undefined ? null : input.line3,
    town: input.town,
    state: input.state === undefined ? null : input.state,
    postCode: input.postCode,
    country: input.country,
  };
}

const CreatePhysicalAddressRequest_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[{"value":"Internal JAVA to NODE request for creating physical address\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entityId","default":{"kind":"nothing"},"name":"entityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"addressType","default":{"kind":"nothing"},"name":"addressType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PhysicalAddressType"}},"parameters":[]}},{"annotations":[],"serializedName":"line1","default":{"kind":"nothing"},"name":"line1","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"line2","default":{"kind":"just","value":null},"name":"line2","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"line3","default":{"kind":"just","value":null},"name":"line3","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"town","default":{"kind":"nothing"},"name":"town","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"just","value":null},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"postCode","default":{"kind":"nothing"},"name":"postCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"country","default":{"kind":"nothing"},"name":"country","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Country"}},"parameters":[]}}]}},"name":"CreatePhysicalAddressRequest","version":{"kind":"nothing"}}};

export const snCreatePhysicalAddressRequest: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"CreatePhysicalAddressRequest"};

export function texprCreatePhysicalAddressRequest(): ADL.ATypeExpr<CreatePhysicalAddressRequest> {
  return {value : {typeRef : {kind: "reference", value : snCreatePhysicalAddressRequest}, parameters : []}};
}

/**
 * Internal DTO for a physical address, shared across the app/admin request models
 */
export interface InternalPhysicalAddressDTO {
  line1: common_strings.StringNE;
  line2: (common_strings.StringNE|null);
  line3: (common_strings.StringNE|null);
  town: common_strings.StringNE;
  state: (common_strings.StringNE|null);
  postCode: common_strings.StringNE;
  country: common.Country;
}

export function makeInternalPhysicalAddressDTO(
  input: {
    line1: common_strings.StringNE,
    line2?: (common_strings.StringNE|null),
    line3?: (common_strings.StringNE|null),
    town: common_strings.StringNE,
    state?: (common_strings.StringNE|null),
    postCode: common_strings.StringNE,
    country: common.Country,
  }
): InternalPhysicalAddressDTO {
  return {
    line1: input.line1,
    line2: input.line2 === undefined ? null : input.line2,
    line3: input.line3 === undefined ? null : input.line3,
    town: input.town,
    state: input.state === undefined ? null : input.state,
    postCode: input.postCode,
    country: input.country,
  };
}

const InternalPhysicalAddressDTO_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[{"value":"Internal DTO for a physical address, shared across the app/admin request models\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"line1","default":{"kind":"nothing"},"name":"line1","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"line2","default":{"kind":"just","value":null},"name":"line2","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"line3","default":{"kind":"just","value":null},"name":"line3","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"town","default":{"kind":"nothing"},"name":"town","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"state","default":{"kind":"just","value":null},"name":"state","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"postCode","default":{"kind":"nothing"},"name":"postCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"country","default":{"kind":"nothing"},"name":"country","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Country"}},"parameters":[]}}]}},"name":"InternalPhysicalAddressDTO","version":{"kind":"nothing"}}};

export const snInternalPhysicalAddressDTO: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"InternalPhysicalAddressDTO"};

export function texprInternalPhysicalAddressDTO(): ADL.ATypeExpr<InternalPhysicalAddressDTO> {
  return {value : {typeRef : {kind: "reference", value : snInternalPhysicalAddressDTO}, parameters : []}};
}

export type SlackNotificationType = 'info' | 'warn' | 'error';
export const valuesSlackNotificationType : SlackNotificationType[] = ['info', 'warn', 'error'];

const SlackNotificationType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"info","default":{"kind":"nothing"},"name":"info","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"warn","default":{"kind":"nothing"},"name":"warn","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SlackNotificationType","version":{"kind":"nothing"}}};

export const snSlackNotificationType: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"SlackNotificationType"};

export function texprSlackNotificationType(): ADL.ATypeExpr<SlackNotificationType> {
  return {value : {typeRef : {kind: "reference", value : snSlackNotificationType}, parameters : []}};
}

export interface SlackNotificationAction {
  label: common_strings.StringNE;
  body: common_strings.StringNE;
  url: common_strings.StringNE;
}

export function makeSlackNotificationAction(
  input: {
    label: common_strings.StringNE,
    body: common_strings.StringNE,
    url: common_strings.StringNE,
  }
): SlackNotificationAction {
  return {
    label: input.label,
    body: input.body,
    url: input.url,
  };
}

const SlackNotificationAction_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"label","default":{"kind":"nothing"},"name":"label","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"body","default":{"kind":"nothing"},"name":"body","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"url","default":{"kind":"nothing"},"name":"url","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"SlackNotificationAction","version":{"kind":"nothing"}}};

export const snSlackNotificationAction: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"SlackNotificationAction"};

export function texprSlackNotificationAction(): ADL.ATypeExpr<SlackNotificationAction> {
  return {value : {typeRef : {kind: "reference", value : snSlackNotificationAction}, parameters : []}};
}

export type SlackChannel = 'awcNotification' | 'datadogProdMonitoring' | 'opsPlatformAlerts';
export const valuesSlackChannel : SlackChannel[] = ['awcNotification', 'datadogProdMonitoring', 'opsPlatformAlerts'];

const SlackChannel_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"awcNotification","default":{"kind":"nothing"},"name":"awcNotification","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"datadogProdMonitoring","default":{"kind":"nothing"},"name":"datadogProdMonitoring","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"opsPlatformAlerts","default":{"kind":"nothing"},"name":"opsPlatformAlerts","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SlackChannel","version":{"kind":"nothing"}}};

export const snSlackChannel: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"SlackChannel"};

export function texprSlackChannel(): ADL.ATypeExpr<SlackChannel> {
  return {value : {typeRef : {kind: "reference", value : snSlackChannel}, parameters : []}};
}

export interface SlackNotification {
  kind: SlackNotificationType;
  message: common_strings.StringNE;
  channel: SlackChannel;
  action: (SlackNotificationAction|null);
}

export function makeSlackNotification(
  input: {
    kind: SlackNotificationType,
    message: common_strings.StringNE,
    channel: SlackChannel,
    action: (SlackNotificationAction|null),
  }
): SlackNotification {
  return {
    kind: input.kind,
    message: input.message,
    channel: input.channel,
    action: input.action,
  };
}

const SlackNotification_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"kind","default":{"kind":"nothing"},"name":"kind","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"SlackNotificationType"}},"parameters":[]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"channel","default":{"kind":"nothing"},"name":"channel","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"SlackChannel"}},"parameters":[]}},{"annotations":[],"serializedName":"action","default":{"kind":"nothing"},"name":"action","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.internalapi","name":"SlackNotificationAction"}},"parameters":[]}]}}]}},"name":"SlackNotification","version":{"kind":"nothing"}}};

export const snSlackNotification: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"SlackNotification"};

export function texprSlackNotification(): ADL.ATypeExpr<SlackNotification> {
  return {value : {typeRef : {kind: "reference", value : snSlackNotification}, parameters : []}};
}

export interface Ok {
  message: common_strings.StringNE;
}

export function makeOk(
  input: {
    message?: common_strings.StringNE,
  }
): Ok {
  return {
    message: input.message === undefined ? "OK" : input.message,
  };
}

const Ok_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"message","default":{"kind":"just","value":"OK"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Ok","version":{"kind":"nothing"}}};

export const snOk: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"Ok"};

export function texprOk(): ADL.ATypeExpr<Ok> {
  return {value : {typeRef : {kind: "reference", value : snOk}, parameters : []}};
}

export interface CreatePhysicalAddressResponse {
  id: ferovinum_app_db.PhysicalAddressId;
}

export function makeCreatePhysicalAddressResponse(
  input: {
    id: ferovinum_app_db.PhysicalAddressId,
  }
): CreatePhysicalAddressResponse {
  return {
    id: input.id,
  };
}

const CreatePhysicalAddressResponse_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.internalapi","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PhysicalAddressId"}},"parameters":[]}}]}},"name":"CreatePhysicalAddressResponse","version":{"kind":"nothing"}}};

export const snCreatePhysicalAddressResponse: ADL.ScopedName = {moduleName:"ferovinum.app.internalapi", name:"CreatePhysicalAddressResponse"};

export function texprCreatePhysicalAddressResponse(): ADL.ATypeExpr<CreatePhysicalAddressResponse> {
  return {value : {typeRef : {kind: "reference", value : snCreatePhysicalAddressResponse}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.internalapi.InternalApiRequests" : InternalApiRequests_AST,
  "ferovinum.app.internalapi.CreatePhysicalAddressRequest" : CreatePhysicalAddressRequest_AST,
  "ferovinum.app.internalapi.InternalPhysicalAddressDTO" : InternalPhysicalAddressDTO_AST,
  "ferovinum.app.internalapi.SlackNotificationType" : SlackNotificationType_AST,
  "ferovinum.app.internalapi.SlackNotificationAction" : SlackNotificationAction_AST,
  "ferovinum.app.internalapi.SlackChannel" : SlackChannel_AST,
  "ferovinum.app.internalapi.SlackNotification" : SlackNotification_AST,
  "ferovinum.app.internalapi.Ok" : Ok_AST,
  "ferovinum.app.internalapi.CreatePhysicalAddressResponse" : CreatePhysicalAddressResponse_AST
};
